var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.type == 'signup')?[_c('PCSignUp')]:[_c('PCLogin')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }